import React from "react";

/**
 * The benchmark report's own front page, as a thumbnail.
 *
 * Drawn once at its design size (132×186) and scaled, so the type stays in proportion wherever it
 * appears — full size beside the download form, half size in the banner that promotes it.
 *
 * Two things it has to survive: it sits on the same near-black navy as itself in the banner, so it
 * carries a pale-blue halo to lift off that surface; and iOS inflates very small type, so the
 * stack is a flex column with the imprint pushed down by `mt-auto` and the title clamped — nothing
 * is absolutely positioned where growing text can collide with it.
 */
export default function ReportCover({ scale = 1, tilt = 0, testId = "report-cover" }) {
  return (
    <div className="shrink-0" style={{ width: 132 * scale, height: 186 * scale }}>
      <div
        data-testid={testId}
        className="relative flex flex-col rounded-lg bg-[#0B1220] p-4 ring-1 ring-[#7da9ff]/25"
        style={{
          width: 132,
          height: 186,
          transform: `scale(${scale}) rotate(${tilt}deg)`,
          transformOrigin: "top left",
          WebkitTextSizeAdjust: "100%",
          textSizeAdjust: "100%",
          boxShadow:
            "0 0 0 5px rgba(125,169,255,0.07), 0 0 26px -4px rgba(61,123,255,0.5), 0 18px 40px -14px rgba(0,0,0,0.65)",
        }}
      >
        <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded bg-white">
          <svg viewBox="0 0 24 24" className="h-3 w-3" fill="none" stroke="#0B1220" strokeWidth="2.4">
            <path d="M4 7h7M4 12h12M4 17h7" strokeLinecap="round" />
            <circle cx="18" cy="7" r="2.4" fill="#0055FF" stroke="none" />
            <circle cx="18" cy="17" r="2.4" fill="#0055FF" stroke="none" />
          </svg>
        </span>
        <div className="mt-4 text-[6px] tracking-[0.2em] uppercase font-bold text-[#60A5FA]">2026 Edition</div>
        <div
          className="mt-1.5 text-[11px] font-semibold text-white leading-[1.25]"
          style={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}
        >
          UK Financial Services CPL Benchmark <span className="text-[#60A5FA]">Report.</span>
        </div>
        <div className="mt-2 h-0.5 w-6 shrink-0 bg-[#0055FF]" />
        <div className="mt-2 space-y-1">
          {[86, 64, 74].map((w, i) => (
            <div key={i} className="flex items-center gap-1.5">
              <div className="h-[3px] rounded-full bg-white/25" style={{ width: `${w * 0.55}px` }} />
              <div className="h-[3px] w-3 rounded-full bg-[#0055FF]/70" />
            </div>
          ))}
        </div>
        <div className="mt-auto pt-2 text-[5.5px] leading-none text-slate-500">Connexis Group Ltd · connex.is</div>
      </div>
    </div>
  );
}
